export const SSO_LOGIN_CREDENTIALS_FLAG = 'ssoLogin';
